export default async (zipcode) => {
  const url = new URL("https://smartystreet.powerthepolls.org/dev/zip");
  url.searchParams.append("zipcode", zipcode);
  return fetch(url.toString())
    .then((response) => response.json(), (error) => console.log("SmartyStreets Error:", error))
    .then((response) => {
    let result = response[0];
    if (result.reason) {
      return { error: result.reason };
    }
    let cities = new Set();
    let counties = new Set();
    let states = new Map(); // Abbreviation to full name
    let defaultCityState = result.zipcodes[0];
    if (result.city_states) {
      result.city_states
        .filter((city) => (city.mailable_city)) // only include mailable cities
        .forEach((city) => cities.add(city.city));
    }
    counties.add(defaultCityState.county_name);
    states.set(defaultCityState.state_abbreviation, defaultCityState.state);
    if (defaultCityState.alternate_counties) {
      defaultCityState.alternate_counties.forEach((county) => {
        counties.add(county.county_name);
        states.set(county.state_abbreviation, county.state);
      });
    }
    return {
      zip: defaultCityState.zipcode,
      cities: cities,
      counties: counties,
      states: states,
    };
  });
};
//# sourceMappingURL=zipGeocoding.js.map
